<template>
  <Modal v-model="visible" @on-ok="ok" @on-cancel="cancel" :loading="modalLoading"  closable mask-closable
     :okText="getTranslation('c006')" :cancelText="getTranslation('b182')" :title="title"
    width="40">
    <Row class="field-line warning-title" type="flex" v-if="this.kindList.length==0">
      <Col flex="24" style="text-align: center;">
        {{ getTranslation('m199') }}
      </Col>
    </Row>
     <Row class="field-line" type="flex">
      <Col flex="4" class="desc-field">
      {{ getTranslation('m141') }}<Icon type="md-star" class="need-icon" />
      </Col>
      <Col flex="20">
       <Select :transfer="true" style="max-width:100%" v-model="machine.kind" :placeholder="getTranslation('m034')"
        :filterable="true">
        <Option v-for="item in kindList" :value="item.id" :key="item.id">{{ item.name }}</Option>
      </Select>
      </Col>
    </Row>
    <Row class="field-line" type="flex">
      <Col flex="4" class="desc-field">
      {{ getTranslation('m010') }}<Icon type="md-star" class="need-icon" />
      </Col>
      <Col flex="20">
      <Input v-model="machine.code" maxlength="50" />
      </Col>
    </Row>
    <Row class="field-line" type="flex">
      <Col flex="4" class="desc-field">
      {{ getTranslation('m011') }}<Icon type="md-star" class="need-icon" />
      </Col>
      <Col flex="20">
      <Input v-model="machine.name" maxlength="50" />
      </Col>
    </Row>
    
    <Row class="field-line" type="flex">
      <Col flex="4" class="desc-field">
      {{ getTranslation('m012') }}<Icon type="md-star" class="need-icon" />
      </Col>
      <Col flex="12">
      <Select :transfer="true" style="max-width:100%" v-model="machine.pl_id" :placeholder="getTranslation('m034')"
        :filterable="true">
        <Option v-for="item in productline" :value="item.id" :key="item.id">{{ item.name }}</Option>
      </Select>
      </Col>
      <Col flex="3" class="desc-field">
      {{ getTranslation('m013') }}
      </Col>
      <Col flex="5">
      <Input v-model="machine.seq" type="number" />
      </Col>
    </Row>
    <Row class="field-line" type="flex">
      <Col flex="4" class="desc-field">
      {{ getTranslation('m014') }}<Icon type="md-star" class="need-icon" />
      </Col>
      <Col flex="12">
      <Input v-model="machine.address" />
      </Col>
      <Col flex="3" class="desc-field">
      {{ getTranslation('m029') }}
      </Col>
      <Col flex="5">
      <Input v-model="machine.port" type="number" />
      </Col>
    </Row>
    <Row class="field-line" type="flex">
      <Col flex="4" class="desc-field">
      {{ getTranslation('m015') }}
      </Col>
      <Col flex="3">
      <Input v-model="machine.slave_id" type="number" />
      </Col>
      <Col flex="11" class="slave-tips">
      {{ getTranslation('m031') }}
      </Col>
      <Col flex="6" class="auto-start">
      <Checkbox v-model="autoStartComputed">{{ getTranslation('m030') }}</Checkbox>
      </Col>
    </Row>
    <Row class="field-line" type="flex">
      <Col flex="4" class="desc-field">
      {{ getTranslation('m016') }}
      </Col>
      <Col flex="20">
      <Input type="textarea" v-model="machine.remark" :rows="3" maxlength="200"  />
      </Col>
    </Row>
    <div slot="footer">
        <Row type="flex" class="menu-actions">
          <Col flex="1" class="flex-right">
            <Button type="text" @click="cancel" icon="md-close" >{{ getTranslation('b182') }}</Button>&nbsp;
            <Button type="primary" @click="ok" icon="md-checkmark" >{{ getTranslation('c006') }}</Button>            
          </Col>
        </Row>
      </div>
  </Modal>

</template>
<script>
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { Modal, Row, Col, Input, Select, Option, Checkbox, Icon, Button } from 'view-design';
import { mapGetters } from 'vuex'
import { checkSeqCorrect, isValidIPv4,postJsError } from '@/util/util.js'
import { EventBus } from '@/store/event-bus.js';

export default {
  name: 'MachineEdit', // 组件名称
  components: {
    Modal, Row, Col, Input, Select, Option, Checkbox, Icon,Button
  },
  props: {
    propVisible: Boolean,
    editId: Number,
    isCopy:Boolean
  },
  data() {
    return {
      machine: {},
      productline: [],
      title: '',
      modalLoading: true,
      kindList: [],
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    visible: {
      get() { return this.propVisible },
      set(val) { this.$emit('input', val) }
    },
    autoStartComputed: {
      get() {
        return this.machine.auto_start == 1;
      },
      set(val) {
        this.machine.auto_start = val ? 1 : 0;
      }
    }
    
    
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.getMachineKindList();
        if (this.editId > 0 && !this.isCopy) {
          this.title = this.getTranslation('m006');
          this.getOneMachine(this.editId)
        } else if(this.editId > 0 && this.isCopy){
          this.getOneMachine(this.editId)
          this.title = this.getTranslation('m005');
        }else {
          this.title = this.getTranslation('m005');
          this.machine = {
            "seq": 1,
            "port": 502,
            "slave_id": 1,
            "auto_start": 1
          }
        }
      }
    }
  },

  created() {
    this.getProductLine();
  },
  methods: {
    getOneMachine(id) {
      let url = API_URL["machineGetOne"];
      let params = {
        id: id
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.machine = res.data.data;
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    getMachineKindList() {
      let url = API_URL["machineKindList"];
   
      axios.get(url)
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.kindList = res.data.data.list || [];
          } 
        })
        .catch((err) => {
          postJsError(err)         
        })      
    },
    ok() {
      let _this = this;
      this.modalLoading = true;
      if (!this.validateForm()) {
        this.modalLoading = false;
        this.resetModal();
        return;
      }
      let url = API_URL["machineAdd"];
      if (this.editId > 0 && !this.isCopy) {
        url = API_URL["machineUpdate"];
      }
      let params = this.machine;
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code && res.data.code == 200) {
            if (this.editId > 0 && !this.isCopy) {
              this.$Message.success(this.getTranslation('m020'));
            } else {
              EventBus.$emit('machine-add');
              this.$Message.success(this.getTranslation('m021'));
            }
            this.visible = false
            _this.$emit("refresh-page")

          } else if (res && res.data && res.data.code && res.data.msg) {
            this.$Message.error(res.data.msg);
            this.modalLoading = false;
            this.resetModal();
          } else {
            this.modalLoading = false;
            this.resetModal();
          }
        })
        .catch((err) => {
          postJsError(err)
          this.modalLoading = false;
          this.resetModal();
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    validateForm() {
      let errorMsg = '';
      let isValid = true;
      this.machine.seq = Number(this.machine.seq);
      this.machine.port = Number(this.machine.port);
      this.machine.slave_id = Number(this.machine.slave_id);
      if (!this.machine.name || this.machine.name.length < 2) {
        errorMsg = this.getTranslation('m023');
        isValid = false;
      } else if (!this.machine.code || this.machine.code.length < 2) {
        errorMsg = this.getTranslation('m024');
        isValid = false;
      } else if (!this.machine.kind ) {
        errorMsg = this.getTranslation('m142');
        isValid = false;
      } else if (!this.machine.pl_id) {
        errorMsg = this.getTranslation('m044');
        isValid = false;
      } else if (!checkSeqCorrect(this.machine.seq)) {
        errorMsg = this.getTranslation('p011');
        isValid = false;
      } else if (!this.machine.address) {
        errorMsg = this.getTranslation('m025');
        isValid = false;
      } else if (!isValidIPv4(this.machine.address)) {
        errorMsg = this.getTranslation('m042');
        isValid = false;
      } else if (!checkSeqCorrect(this.machine.port)) {
        errorMsg = this.getTranslation('m026');
        isValid = false;
      } else if (!checkSeqCorrect(this.machine.slave_id)) {
        errorMsg = this.getTranslation('m043');
        isValid = false;
      }
      if (errorMsg) {
        this.$Message.error(errorMsg);
      }
      return isValid;
    },
    resetModal() {
      this.$nextTick(() => {
        this.modalLoading = true;
      });
    },
    cancel() {
      this.visible = false;
    },
    async getProductLine() {
      let url = API_URL["productlineGetAll"];
      let response = await axios.get(url);
      if (response && response.data && response.data.code == 200) {
        this.productline = response.data.data
        this.productline && (this.productline = this.productline.filter(item => item.state == 0));
      } else {
        this.$Message.error(this.getTranslation('p013'));
      }
    },
  },

}
</script>

<style scoped>
@import url('../../../assets/style/list.css'); 
.desc-field {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 3%;
  font-size: 0.9rem;
}

.field-line {
  margin-bottom: 8px;
}

.slave-tips {
  display: flex;
  align-items: center;
  padding-left: 1%;
  font-size: 0.9rem;
}

.auto-start {
  font-size: 0.9rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.warning-title {
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  color: #856404;
  font-weight: bold;
  padding: 8px;
  text-align: center;
  margin-bottom: 8px;
}
</style>